export const numberFormat = (value) =>
    new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2,
    }).format(value);

export const formatFloat = (number, precision, locales) =>
    new Intl.NumberFormat(locales, {
        maximumFractionDigits: precision,
    }).format(number);
